import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@ui/components/ui/dialog";

// Official notice files from the Commission (Implementing Regulation (EU)
// 2025/1960, Annex I). The image may not be edited, so it is shown as is.
const notices = {
  hr: {
    src: "/images/legal-guarantee/notice-hr.png",
    url: "https://europa.eu/youreurope/jamstva_hr",
  },
  de: {
    src: "/images/legal-guarantee/notice-de.png",
    url: "https://europa.eu/youreurope/garantien",
  },
} as const;

export function LegalGuaranteeNotice({ locale }: Readonly<{ locale: string }>) {
  const { t } = useTranslation();
  const notice = locale.startsWith("de") ? notices.de : notices.hr;

  return (
    <Dialog>
      <DialogTrigger className="inline-flex items-center gap-1.5 text-small text-primary underline underline-offset-2 transition-colors duration-150 hover:text-primary-darker1">
        <ShieldCheck className="size-4" strokeWidth={1.5} aria-hidden />
        {t("SingleProductPage.legalGuarantee.trigger")}
      </DialogTrigger>
      <DialogContent className="max-h-[92dvh] w-[min(40rem,calc(100vw-2rem))] max-w-none overflow-y-auto p-4 pt-12 sm:p-6 sm:pt-14">
        <DialogTitle className="sr-only">
          {t("SingleProductPage.legalGuarantee.title")}
        </DialogTitle>
        <DialogDescription className="sr-only">
          {t("SingleProductPage.legalGuarantee.description")}
        </DialogDescription>
        <img
          src={notice.src}
          alt={t("SingleProductPage.legalGuarantee.alt")}
          width={1654}
          height={2339}
          className="h-auto w-full"
        />
        <a
          href={notice.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-small text-primary underline underline-offset-2"
        >
          {notice.url.replace("https://", "")}
        </a>
      </DialogContent>
    </Dialog>
  );
}
